/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { withStyles } from '@mui/styles';

const setColor = (value) => {
  if (value > 6) return '#D0021B';
  if (value < 4) return '#8BDB2D';
  return '#F5A623';
};

const ComplexitySlider = function ComplexitySlider({ enableChanges, showSwitch, setNewValue, newValue }) {
  const ComSlider = withStyles({
    root: { color: setColor(newValue), height: 3 },
    track: {
      border: 'none',
    },
    thumb: {
      height: 16,
      width: 16,
      backgroundColor: setColor(newValue),
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: 'inherit',
      },
      '&:before': {
        display: 'none',
      },
    },
    active: {},
    valueLabel: {
      lineHeight: 1.2,
      fontSize: 12,
      background: 'unset',
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: setColor(newValue),
      transformOrigin: 'bottom left',
      transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
      '&:before': { display: 'none' },
      '&.MuiSlider-valueLabelOpen': {
        transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
      },
      '& > *': {
        transform: 'rotate(45deg)',
      },
    },
  })(Slider);

  return (
    <Box sx={{ width: 'inherit' }}>
      <ComSlider
        aria-label="Set Complexity"
        step={1}
        valueLabelDisplay="on"
        marks
        size="small"
        min={1}
        max={9}
        value={newValue}
        disabled={!(showSwitch && enableChanges)}
        onChangeCommitted={(event, v) => {
          setNewValue(v);
        }}
      />
    </Box>
  );
};
export default ComplexitySlider;
